import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import SmallTitle from '../../../../shared/library/typography/small-title';
import {WHITE, CHARCOAL} from '../../../../shared/style/colors';

const ListItem = glamorous.li(
  {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    cursor: 'pointer'
  },
  ({selected}) => ({
    backgroundColor: selected ? CHARCOAL : null
  })
);

const Image = glamorous.img({
  width: 20,
  marginRight: 8
});

export default function ComparisonInputResult(props) {
  const {onMouseEnter, onClick, service, selected} = props;

  return (
    <ListItem onMouseEnter={onMouseEnter} onClick={onClick} selected={selected}>
      <Image src={service.image_url} />
      <SmallTitle
        style={{
          color: selected ? WHITE : null
        }}
      >
        {service.name}
      </SmallTitle>
    </ListItem>
  );
}

ComparisonInputResult.propTypes = {
  service: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};
